export default "__VITE_ASSET__CWhQx2N4__"